import { ChartCanvas } from "@/components/analytics/ChartCanvas";
import type { KpiRow } from "@/lib/reporting.api";
import { useKpiComparisonChartConfig } from "../hooks/useKpiComparisonChartConfig";

export function KpiComparisonChart({
  label,
  rows,
  color,
}: {
  label: string;
  rows: KpiRow[];
  color: string;
}) {
  const topRows = rows.slice(0, 10);
  const chartConfig = useKpiComparisonChartConfig(topRows, color);

  if (topRows.length === 0) {
    return (
      <p className="py-12 text-center text-[11.5px] text-muted-foreground">
        Aucune donnée sur cette période.
      </p>
    );
  }

  return (
    <ChartCanvas
      label={label}
      height={Math.max(180, topRows.length * 34)}
      config={chartConfig}
    />
  );
}
